import { useState, useEffect } from 'react';
import { supabase, getSessionUser } from '../../supabase';
import { getNormalizedRole } from '../../utils';
import type { UserSession } from './types';

export function useUserSession(): UserSession {
  const [user, setUser] = useState<any>(null);
  const [userRole, setUserRole] = useState<string>('');
  const [assignedBrandIds, setAssignedBrandIds] = useState<string[]>([]);

  // Get user and role from Supabase
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const authUser = await getSessionUser();
        if (authUser?.id) {
          setUser(authUser);
          // Fetch user role and assigned brands from database
          const { data: userData } = await supabase
            .from('users')
            .select('role, assignedBrandIds')
            .eq('id', authUser.id)
            .single();
          if (userData?.role) {
            setUserRole(getNormalizedRole(userData.role));
            if (userData.assignedBrandIds) {
              setAssignedBrandIds(userData.assignedBrandIds);
            }
          }
        }
      } catch (err) {
        // Silent catch — tidak login di localhost itu normal
      }
    };

    fetchUserData();
  }, []);

  return { user, userRole, assignedBrandIds, setAssignedBrandIds };
}
